import gql from "graphql-tag";

const comboKementerian = gql`
  query comboKementerian {
    kementerianList(where: { status: "A" }) {
      id
      kod_kementerian
      nama_kementerian
    }
  }
`;

const comboAgensi = gql`
  query comboAgensi {
    agensiList(where: { status: "A" }) {
      id
      kod_agensi
      nama_agensi
    }
  }
`;

const comboNegeri = gql`
  query comboNegeri {
    negeriList(where: { status: "A" }) {
      id
      kod_negeri
      nama_negeri
    }
  }
`;

// const comboDaerah = gql`
//   query comboDaerah {
//     daerahList(where: { status: "A" }) {
//       id
//       kod_negeri
//       nama_negeri
//     }
//   }
// `;

const comboSkimJenisList = gql`
  query comboSkimJenisList {
    skimJenisList {
      id
      kod
      nama
    }
  }
`;

const comboSkimKlasifikasiList = gql`
  query comboSkimKlasifikasiList {
    skimKlasifikasiList {
      id
      kod
      nama
    }
  }
`;

const comboSkimPerkhidmatan = gql`
  query comboSkimPerkhidmatan {
    kodPerkhidmatanSkimList(where: {}) {
      id
      kod
      kod2
      nama
      status
    }
  }
`;

const comboBahCaw = gql`
  query comboBahCaw {
    bahCawJanmList(where: {jenis:"BAHAGIAN"}) {
      id
      kod
      nama
      jenis
    }
  }
`;

const comboSkimPerkhidmatanWithoutAuth = gql`
  query comboSkimPerkhidmatanWithoutAuth {
    skimPerkhidmatanListWithoutAuth {
      id
      kod
      nama
    }
  }
`;

// Example multiple combo in 1 query
const comboPeperiksaan = gql`
  query comboPeperiksaan {
    kementerianList(where: { status: "A" }) {
      id
      kod_kementerian
      nama_kementerian
    }
    agamaList(where: { status: "A" }) {
      id
      kod_agama
      nama_agama
    }
    bangsaList(where: { status: "A" }) {
      id
      kod_bangsa
      nama_bangsa
    }
  }
`;

const comboPengguna = gql`
  query comboPengguna {
    agensiList(where: { status: "A" }) {
      id
      kod_agensi
      nama_agensi
    }
    skimPerkhidmatanList {
      id
      kod_skim
      nama_skim
      jenis_skim
      klasifikasi_skim
      gred
    }
  }
`;

const comboBorangPeperiksaan = gql`
  query comboBorangPeperiksaan {
    kementerianList(where: { status: "A" }) {
      id
      kod_kementerian
      nama_kementerian
    }
    negeriList(where: { status: "A" }) {
      id
      kod_negeri
      nama_negeri
    }
    pusatPeperiksaanList(where: { status: "A" }) {
      id
      kod_pusat
      nama_pusat
    }
    jenisJabatanList(where: { status: "A" }) {
      id
      kod_jenis
      nama_jenis
    }
    agensiList(where: { status: "A" }) {
      id
      kod_agensi
      nama_agensi
    }
    tarafPendidikanList(where: { status: "A" }) {
      id
      kod_taraf
      nama_taraf
    }
    pendidikanInstitutList(where: { status: "A" }) {
      id
      kod_institut
      nama_institut
    }
    pendidikanMajorList(where: { status: "A" }) {
      id
      kod_major
      nama_major
    }
  }
`;

const comboBorangPerkhidmatan = gql`
  query comboBorangPerkhidmatan {
    kementerianList(where: { status: "A" }) {
      id
      kod_kementerian
      nama_kementerian
    }
    negeriList(where: { status: "A" }) {
      id
      kod_negeri
      nama_negeri
    }
    agamaList(where: { status: "A" }) {
      id
      kod_agama
      nama_agama
    }
    agensiList(where: { status: "A" }) {
      id
      kod_agensi
      nama_agensi
    }
    bangsaList(where: { status: "A" }) {
      id
      kod_bangsa
      nama_bangsa
    }
    jenisJabatanList(where: { status: "A" }) {
      id
      kod_jenis
      nama_jenis
    }
    statusPerkahwinanList(where: { status: "A" }) {
      id
      kod_sts_kahwin
      nama_sts_kahwin
    }
  }
`;

export {
  comboKementerian,
  comboAgensi,
  comboPeperiksaan,
  comboNegeri,
  comboBahCaw,
  comboSkimPerkhidmatan,
  comboSkimPerkhidmatanWithoutAuth,
  comboSkimJenisList,
  comboSkimKlasifikasiList,
  comboPengguna,
  comboBorangPeperiksaan,
  comboBorangPerkhidmatan,
};
